import { render, staticRenderFns } from "./UpOrDowngradeVehicleCard.vue?vue&type=template&id=054c3446"
import script from "./UpOrDowngradeVehicleCard.vue?vue&type=script&lang=js"
export * from "./UpOrDowngradeVehicleCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports